import React from 'react'
import Draggable from 'react-draggable'
import type { ModalProps } from 'react-bootstrap'
import { ModalDialog } from 'react-bootstrap'

export const DraggableModal = (props: ModalProps) => {
  return (
    <Draggable handle=".drag-handle">
      <ModalDialog {...props} />
    </Draggable>
  )
}
